<template>
  <v-card class="pa-3">
    <v-card-title>{{ formattedName }}</v-card-title>
    <v-card-text>
      <div>
        <strong>Number of Images:</strong> {{ page.description.images.length }}
      </div>
      <!-- Row of chips for missing information -->
      <div class="d-flex flex-wrap gap-2 my-2">
        <v-chip
          v-if="!page.metaTitle"
          color="red"
          text-color="white"
          small
          outlined
        >
          Meta Title Missing
        </v-chip>
        <v-chip
          v-if="!page.metaDescription"
          color="red"
          text-color="white"
          small
          outlined
        >
          Meta Description Missing
        </v-chip>
        <v-chip
          v-if="!page.description.descriptionHtml"
          color="red"
          text-color="white"
          small
          outlined
        >
          Description Missing
        </v-chip>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
     
        class="ma-0"
        @click="openPage(page.pathname)"
      >
        Open Page
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import IPage from '@/interfaces/IPage';
import { formatPathSegmentToTitle } from '@/utils/urlUtils';

const props = defineProps<{
  page: IPage;
}>();

const activeUrlStore = useActiveUrlStore();

// Use the new helper function to format the pathname
const formattedName = computed(() => formatPathSegmentToTitle(props.page.pathname));

const openPage = (pathname: string) => {
  const url = activeUrlStore.getUrlByPathname(pathname);
  if (url) {
    window.open(url, '_blank');
  } else {
    console.warn('URL not found for pathname:', pathname);
  }
};
</script>
